import { useThemeStore } from "@terminal/components/theme-controller/stores/useThemeStore";
import { isDarkTheme } from "@terminal/components/theme-controller/utils/theme-utils/theme-utils";
import { getCanvasDataUrl } from "@terminal/views/insight-feed/utils/fetchStylesUtils";
import { themes } from "@toggle/design-system/src/design-tokens/themes/themes";

const inlineComputedStyles = (root: HTMLElement) => {
  const elements = [
    root,
    ...Array.from(root.querySelectorAll<HTMLElement | SVGElement>('*')),
  ];
  const cssTexts = elements.map(el => window.getComputedStyle(el).cssText);

  elements.forEach((el, index) => {
    if (cssTexts[index]) {
      el.style.cssText = cssTexts[index];
    }
  });
};

const inlineSvgIcons = (root: HTMLElement) => {
  root.querySelectorAll('svg').forEach(svg => {
    const { width, height } = svg.getBoundingClientRect();

    svg.style.color = window.getComputedStyle(svg).color;

    const serialized = new XMLSerializer().serializeToString(svg);
    const img = document.createElement('img');

    img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
      serialized
    )}`;
    img.style.width = `${width}px`;
    img.style.height = `${height}px`;

    svg.parentNode?.replaceChild(img, svg);
  });
};

export const renderChartV2Node = (chartNode: HTMLDivElement): string => {
  const shouldInvertCanvas = isDarkTheme(useThemeStore.getState().themeName);

  const clone = chartNode.cloneNode(true) as HTMLDivElement;

  Object.entries(themes.light_default).forEach(([key, value]) =>
    clone.style.setProperty(key, value)
  );
  clone.style.position = 'fixed';
  clone.style.top = '0';
  clone.style.left = '-99999px';
  clone.style.opacity = '0';
  clone.style.pointerEvents = 'none';
  clone.style.width = `${chartNode.offsetWidth}px`;
  document.body.appendChild(clone);

  try {
    inlineComputedStyles(clone);

    clone.style.position = '';
    clone.style.top = '';
    clone.style.left = '';
    clone.style.opacity = '';
    clone.style.pointerEvents = '';

    inlineSvgIcons(clone);

    const originalCanvases = chartNode.querySelectorAll('canvas');
    const clonedCanvases = clone.querySelectorAll('canvas');

    originalCanvases.forEach((canvas, index) => {
      const clonedCanvas = clonedCanvases[index];

      if (clonedCanvas) {
        const img = document.createElement('img');
        img.src = getCanvasDataUrl(canvas, shouldInvertCanvas);

        const computedStyle = window.getComputedStyle(canvas);
        img.style.cssText = computedStyle.cssText;
        img.style.width = computedStyle.width;
        img.style.height = computedStyle.height;

        clonedCanvas.parentNode?.replaceChild(img, clonedCanvas);
      }
    });

    return clone.outerHTML;
  } finally {
    document.body.removeChild(clone);
  }
};